import { render, staticRenderFns } from "./article-list.vue?vue&type=template&id=bfb051e8&scoped=true&"
import script from "./article-list.vue?vue&type=script&lang=js&"
export * from "./article-list.vue?vue&type=script&lang=js&"
import style0 from "./article-list.vue?vue&type=style&index=0&id=bfb051e8&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bfb051e8",
  null
  
)

export default component.exports